// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"Cadastrar_cabecalho__1ut0q"};